import { css } from '@emotion/react'
import { Theme } from '../settings'

export const Overrides = css`
  //for zoom button on map
  .gmnoprint {
    > div {
      background-color: transparent !important;
      box-shadow: none !important;
    }
  }
  .gm-control-active {
    background-color: ${Theme.colors.midnightBlue} !important;
    width: 25px !important;
    height: 25px !important;
    border-radius: 4px;
    border: 0.5px solid ${Theme.colors.steelBlue} !important;
    top: 10px !important;
    left: 10px !important;
    > img {
      filter: invert(100%) brightness(125%);
    }
    + div {
      top: 10px !important;
      left: 10px !important;
      background-color: transparent !important;
    }
  }
  //for selects in filter drawer

  .MuiPaper-root {
    // top: 138px !important;
    // font-size: 0.8rem;
  }
  .MuiList-padding {
    padding: 4px 0;
  }
  .MuiList-root {
    color: ${Theme.colors.white};
    background-color: ${Theme.colors.midnightBlue};
  }
  .MuiMenuItem-root {
    font-size: 0.8rem;
    text-transform: uppercase;
    &.sub-item-en {
      margin-left: 1.25rem;
    }
    &.sub-item-fa {
      margin-right: 1.25rem;
    }
  }

  .MuiListItem-root.Mui-selected,
  .MuiListItem-root.Mui-selected:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }

  //for year selector
  // .year-selector-paper {
  //   background-color: white;
  // }
  .year-selector-list {
    &.MuiList-root {
      background-color: ${Theme.colors.white};
      color: ${Theme.colors.brightBlue};
      max-height: 12rem;
    }
    .MuiListItem-root.Mui-selected,
    .MuiListItem-root.Mui-selected:hover {
      background-color: rgba(0, 0, 0, 0.3);
    }
    .MuiListItem-button:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
    .MuiMenuItem-root {
      font-size: 0.8rem;
      min-height: 24px;
    }
  }

  //for hamburger dropdown menu
  .dropdown-list {
    .MuiPaper-root {
      .MuiList-root {
        color: ${Theme.colors.black};
        background-color: ${Theme.colors.white};
        .MuiListItem-root {
          text-transform: none;
        }
        .MuiMenuItem-root {
          min-height: 2rem;
          color: ${Theme.colors.red};
          font-weight: 700;
          a {
            :hover {
              text-decoration: none;
            }
            :visited {
              color: ${Theme.colors.red};
            }
          }
        }
      }
    }
  }
  //overrides the default text-align: left (to be able to handle rtl)
  .ReactModal__Body--open {
    text-align: unset;
  }
`
